export default [

     {
          path: '/biadepartment-manager-form-data',
          name: 'BIADepartment',
          component: () => import("@/views/Page/BIADepartment/BIADepartmentManager.vue"),
          meta: {
               title: 'BIA Department Manager',
               permission: 'BIADepartment',
          },
     }
];